import {
  Button,
  InputField,
  InputNumber,
  InputOption,
  InputSelect,
} from "@sellar-io/components";
import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogNavigation,
} from "../../../../components/modal/Dialog";

export const CustomContainerSizeDialog = ({
  volume: initialVolume,
  displayUnit: initialUnit,
  onDismiss,
  onSave,
}: {
  volume: number | undefined;
  displayUnit: string;
  onDismiss: () => void;
  onSave: (size: { volume: number; displayUnit: string }) => void;
}) => {
  const [volume, setVolume] = useState(initialVolume);
  const [displayUnit, setDisplayUnit] = useState(
    initialVolume === undefined ? "" : initialUnit,
  );
  return (
    <Dialog
      active
      onDismiss={onDismiss}
      className="h-auto w-[calc(100%-2rem)] max-w-[500px]"
    >
      <DialogNavigation
        title="Custom container size"
        className="px-4 pt-5 pb-8"
      />
      <DialogContent className="px-4 pb-4">
        <form
          className="flex flex-col gap-6"
          onSubmit={(event) => {
            event.preventDefault();
            event.stopPropagation();
            if (
              volume !== undefined &&
              Number.isFinite(volume) &&
              volume > 0 &&
              displayUnit
            )
              onSave({ volume, displayUnit });
          }}
        >
          <div className="flex flex-col gap-4">
            <InputField
              label="Volume"
              labelClassName="font-semibold"
              containerClassName="min-h-12"
            >
              <InputNumber
                required
                min={0.01}
                step={0.01}
                value={volume ?? ""}
                onChange={(event) =>
                  setVolume(
                    event.target.value === ""
                      ? undefined
                      : Number(event.target.value),
                  )
                }
              />
            </InputField>
            <InputField
              label="Unit"
              labelClassName="font-semibold"
              containerClassName="min-h-12"
            >
              <InputSelect
                required
                className={displayUnit ? undefined : "text-zinc-400"}
                value={displayUnit}
                onChange={(event) => setDisplayUnit(event.target.value)}
              >
                <InputOption value="" disabled>
                  Choose...
                </InputOption>
                {["L", "ml", "cl", "gal", "pt", "oz", "g", "kg"].map((unit) => (
                  <InputOption key={unit} value={unit}>
                    {unit}
                  </InputOption>
                ))}
              </InputSelect>
            </InputField>
          </div>
          <div className="flex justify-end gap-3">
            <Button
              type="submit"
              disabled={
                volume === undefined ||
                !Number.isFinite(volume) ||
                volume <= 0 ||
                !displayUnit
              }
            >
              Confirm
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
